import { useGridMqttSubscription } from '@hooks/mqtt/useGridMqttSubscription';
import { Stack, SxProps, Theme } from '@mui/material';
import {
  DataGridPro,
  DataGridProProps,
  GridApiPro,
  useGridApiRef,
} from '@mui/x-data-grid-pro';
import { MutableRefObject, memo } from 'react';
import { DeviceDataTableRow } from './types';

interface DualViewDataGridProps {
  rowsFirstGrid: DeviceDataTableRow[];
  rowsSecondGrid: DeviceDataTableRow[];
  boxStyles: SxProps<Theme>;
  gridProps: Omit<DataGridProProps, 'rows' | 'apiRef'>;
}

const DualViewDataGrid: React.FC<DualViewDataGridProps> = ({
  rowsFirstGrid,
  rowsSecondGrid,
  boxStyles,
  gridProps,
}) => {
  const apiRef: MutableRefObject<GridApiPro> = useGridApiRef();
  const apiRefSecondGrid: MutableRefObject<GridApiPro> = useGridApiRef();

  useGridMqttSubscription(rowsFirstGrid, apiRef);
  useGridMqttSubscription(rowsSecondGrid, apiRefSecondGrid);

  return (
    <Stack spacing={0.3} direction='row' sx={boxStyles}>
      <DataGridPro {...gridProps} rows={rowsFirstGrid} apiRef={apiRef} />
      <DataGridPro
        {...gridProps}
        rows={rowsSecondGrid}
        apiRef={apiRefSecondGrid}
      />
    </Stack>
  );
};

DualViewDataGrid.displayName = 'DualViewDataGrid';

export default memo(DualViewDataGrid);
